import { Component, OnInit, ErrorHandler } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../../shared/user.service';
import { Search } from '../../shared/user.model';
import swal from 'sweetalert2';



@Component({
  selector: 'app-complaint-grid',
  templateUrl: './complaint-grid.component.html',
  styleUrls: ['./complaint-grid.component.css']
})
export class ComplaintGridComponent implements OnInit {
  itemsPerPage: number=5;
  currentPage: number=1;
  ComplaintDetailsList : any = {};
  data : any = {};  
  totalItems : number;
  s: Search;
  isSearch:boolean = false;
  Comp_id : number;

  title="Complaints";

  constructor(private UserService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler) {
     this.s = new Search();
    this.isSearch = false;
   }

   ngOnInit() { 
    this.GetComplaintDetails(this.itemsPerPage, 1)
  }
  
  GetComplaintDetails(itemsPerPage:any,pageNo:any){
    debugger;
    //alert('Inside');
    this.isSearch = false;
      document.getElementById('loader-spinner').style.display = "block";
      this.data = this.UserService.GetComplaintDetails(itemsPerPage,pageNo);
      this.data.subscribe(
        (response: any) => {
          this.ComplaintDetailsList = response.ComplaintModel;
            this.totalItems = response.TotalItemsCount;
            this.itemsPerPage = itemsPerPage;
            this.currentPage = pageNo;  
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          if (error.status == 401|| error.status == 500) {
            this.errorHandler.handleError(error);
          }
          else if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    } pageChanged(pageNumber: number) {
      if (this.isSearch)
        this.onSearch(this.s, this.itemsPerPage, pageNumber);
      else
        this.GetComplaintDetails(this.itemsPerPage, pageNumber);
    }
  
    itemsPerPageChanged(itemsPerPage: number, pageNo: number) {
      if (this.isSearch)
        this.onSearch(this.s, this.itemsPerPage, pageNo);
      else
        this.GetComplaintDetails(this.itemsPerPage, pageNo);
    }
//delete
    delete(Comp_id){
      swal({
           title: 'Are you sure?', text: "You want to delete!", type: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
          this.data = this.UserService.DeleteComplaint(Comp_id);
          this.data.subscribe(
           (response: any) => {
               this.GetComplaintDetails(this.itemsPerPage,this.currentPage);          
           },(error) => {
            document.getElementById('loader-spinner').style.display = "none";
            if (error.status == 401|| error.status == 500) {
              this.errorHandler.handleError(error);
            }
            else if (error.status == 400) {
              swal('Warning!', error.error.Message, 'warning');
            }
          }       
        ); 
      } 
      })
      }
  //Search item


  onSearch(s, itemsPerPage: number, pageNo: number) {   
    this.isSearch = true;
    let searchText = this.s.SearchText;
    let searchCriteria = this.s.SearchCriteria;
    if (searchText == "" || searchText == null || searchCriteria == "" || searchCriteria == null)
      swal("Warning!", "Please enter the search criteria and search text.", "warning");
    else {
      document.getElementById('loader-spinner').style.display = "block";
      this.UserService.SearchComplaint(searchCriteria, searchText, itemsPerPage, pageNo)
        .subscribe(
          (data: any) => {
            if(data.ComplaintModel.length!=0){              
            this.ComplaintDetailsList = data.ComplaintModel;
            this.totalItems = data.TotalItemsCount;
            this.currentPage = pageNo;
            document.getElementById('loader-spinner').style.display = "none";
          }
          else
          {
          document.getElementById('loader-spinner').style.display = "none";         
          }
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
            if (error.status == 401|| error.status == 500) {
              this.errorHandler.handleError(error);
            }
            else if (error.status == 400) {
              swal('Warning!', error.error.Message, 'warning');
            }
          });
    }
  }



}



// WEBPACK FOOTER //
// ./src/app/Complaints/complaint-grid/complaint-grid.component.ts